export const FETCH_INVESTMENT_ASSETS_INIT = 'FETCH_INVESTMENT_ASSETS_INIT';
export const FETCH_INVESTMENT_ASSETS_SUCCESS = 'FETCH_INVESTMENT_ASSETS_SUCCESS';
export const FETCH_INVESTMENT_ASSETS_FAILURE = 'FETCH_INVESTMENT_ASSETS_FAILURE';

export const CREATE_ORGANIZATION_INIT = 'CREATE_ORGANIZATION_INIT';
export const CREATE_ORGANIZATION_SUCCESS = 'CREATE_ORGANIZATION_SUCCESS';
export const CREATE_ORGANIZATION_FAILURE = 'CREATE_ORGANIZATION_FAILURE';

export const EDIT_ORGANIZATION_INIT = 'EDIT_ORGANIZATION_INIT';
export const EDIT_ORGANIZATION_SUCCESS = 'EDIT_ORGANIZATION_SUCCESS';
export const EDIT_ORGANIZATION_FAILURE = 'EDIT_ORGANIZATION_FAILURE';

export const DELETE_ORGANIZATION_INIT = 'DELETE_ORGANIZATION_INIT';
export const DELETE_ORGANIZATION_SUCCESS = 'DELETE_ORGANIZATION_SUCCESS';
export const DELETE_ORGANIZATION_FAILURE = 'DELETE_ORGANIZATION_FAILURE';
